import {
  TyrianApp
} from './target/scala-3.6.2/cdfweb-fastopt/main.js';

TyrianApp.launch("myapp");
